import { NavigationBackButton, NavigationNextButton } from "../partials/buttons";
import globals from "../partials/global-variables";
import { LeftArrowGray, RightArrowGray } from "../partials/icons";

export default {
  container: {
    width: "100%",
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    "& .navigation-back-button": {
      outline: "0",
      ...NavigationBackButton
    },
    "& .navigation-next-button": {
      ...NavigationNextButton,
      outline: "0",
      "&:hover": {
        "& .question-validation-wrapper": {
          visibility: "visible"
        }
      },
      "&.button--hidden": {
        visibility: "hidden"
      }
    },
    "& .noClickableButton": {
      backgroundColor: globals.colors.gray2,
      border: `1px solid ${globals.colors.gray}`,
      color: globals.colors.gray5
    },
    "& .navigation-back-button.noClickableButton": {
      "&:before": {
        ...LeftArrowGray
      }
    },
    "& .navigation-next-button.noClickableButton": {
      "&:after": {
        ...RightArrowGray
      }
    }
  }
};
